export const asterAccountCategory = 'aster'

// Aster network mapping to EVM chain IDs
export const networkEvmChainIds: Record<string, number | undefined> = {
  ETH: 1,
  BSC: 56,
  ARBITRUM: 42161,
  OPTIMISM: 10,
  POLYGON: 137,
  BASE: 8453,
  AVALANCHE: 43114,
}

export const networkPolkadotChainIds: Record<string, number | undefined> = {}

// Solana network identifier for Aster
export const solanaNetwork = 'SOLANA'
